var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"purChase-box"},_vm._l((_vm.purchaseList),function(item,index){return _c('div',{key:index,staticClass:"purchase-item"},[_c('img',{attrs:{"src":item.img}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }